import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/auth-redirect', '/bind', '/register']
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true
  }
}

router.beforeEach((to, from, next) => {
  console.log(to.redirectedFrom)
  //监听路由切换
  store.commit('clearAxiosArr') // 取消请求
  NProgress.start()
  if (getToken()) {
    /* has token*/
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      if (store.getters.roles.length === 0) {
        // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GetInfo').then(res => {
          // 拉取user_info
          const roles = res.roles

          store.dispatch('GenerateRoutes', { roles }).then(accessRoutes => {
            // 根据roles权限生成可访问的路由表
            router.addRoutes(accessRoutes) // 动态添加可访问路由表
            // 根据角色自动跳转到对应页面（仅首页时触发）
            if (to.path === '/' || to.path === '/index') {
              if (roles.includes('zhaoshengchu_jb')) {
                // 招生处经办 -> 招生维护页面
                next({ path: '/ywpx/student/stuProject/trustees', replace: true })
              } else if (roles.includes('projectAdministrativeHandle')) {
                // 管理经办 -> 项目维护页面
                next({ path: '/ywpx/project/operator', replace: true })
              } else if (roles.includes('zhaoshengchu_cz')) {
                // 招生处处长 -> 待分配招生经办页面
                next({ path: '/ywpx/project/admissionAllocationIndex', replace: true })
              } else {
                next({ ...to, replace: true })
              }
            } else {
              next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
            }
          })
        })
          .catch(err => {
            store.dispatch('FedLogOut').then(() => {
              Message.error(err)
              next({ path: '/' })
            })
          })
      } else {
        // 已有角色信息，首页时也根据角色跳转
        if (to.path === '/' || to.path === '/index') {
          if (store.getters.roles.includes('zhaoshengchu_jb')) {
            next({ path: '/ywpx/student/stuProject/trustees', replace: true })
          } else if (store.getters.roles.includes('projectAdministrativeHandle')) {
            next({ path: '/ywpx/project/operator', replace: true })
          } else {
            next()
          }
        } else {
          next()
        }
      }
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
